export default __webpack_public_path__ + "static/media/upload-dark.ba2546cb.svg";